import { createContext, useContext } from "react";

/**
 * Chapter accent gradient [from, to]. Provided by SlideShell so accent-aware
 * primitives (GradientText, GlassCard glow, Hotspot) pick up the chapter
 * colours automatically.
 */
export const AccentContext = createContext<readonly [string, string]>([
  "#22d3ee",
  "#e879f9",
]);

export const useAccent = () => useContext(AccentContext);
